import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  QueryList,
  ViewChildren,
} from '@angular/core';

import { CommonModule } from '@angular/common';
import { isArray, cloneDeep } from 'lodash-es';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDividerModule } from '@angular/material/divider';
import { MatButtonModule } from '@angular/material/button';
import { FormBuilderComponent } from '../form-buider/form-buider.component';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-form-builder-secondary',
  standalone: true,
  template: `
    <div class="d2c-fb">
      <!-- Input Dataset(s) -->
      <div class="ccard">
        <div class="ch">
          <span class="ic ci-in">
            <svg
              viewBox="0 0 24 24"
              width="18"
              height="18"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="M19 12H5M11 18l-6-6 6-6" />
            </svg>
          </span>
          Input Dataset(s)
          <span class="help2">what this step reads</span>
        </div>
        <div class="cb">
          <div
            *ngFor="let obj of nodePayLoad.input; let i = index"
            class="iorow"
          >
            <mat-form-field appearance="fill">
              <mat-label>{{ nodePayLoad.input_labels[i][0] }}</mat-label>
              <input matInput [(ngModel)]="obj[0]" />
            </mat-form-field>
            <mat-form-field appearance="fill">
              <mat-label>{{ nodePayLoad.input_labels[i][1] }}</mat-label>
              <mat-select [(ngModel)]="obj[1]">
                <mat-option *ngFor="let value of inputSaveType" [value]="value">
                  {{ value }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </div>

      <!-- Output Dataset(s) -->
      <div class="ccard">
        <div class="ch">
          <span class="ic ci-out">
            <svg
              viewBox="0 0 24 24"
              width="15"
              height="15"
              fill="none"
              stroke="currentColor"
              stroke-width="1.8"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path
                d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2Z"
              />
              <path d="M17 21v-8H7v8M7 3v5h8" />
            </svg>
          </span>
          Output Dataset(s)
          <span class="help2">what it writes</span>
        </div>
        <div class="cb">
          <div
            *ngFor="let obj of nodePayLoad.output; let i = index"
            class="iorow"
          >
            <mat-form-field appearance="fill">
              <mat-label>{{ nodePayLoad.output_labels[i][0] }}</mat-label>
              <input matInput [(ngModel)]="obj[0]" />
            </mat-form-field>
            <mat-form-field appearance="fill">
              <mat-label>{{ nodePayLoad.output_labels[i][1] }}</mat-label>
              <mat-select [(ngModel)]="obj[1]">
                <mat-option *ngFor="let value of outPutSaveType" [value]="value">
                  {{ value }}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field appearance="fill" *ngIf="obj[2] !== undefined">
              <mat-label>{{
                nodePayLoad.output_labels[i][2]
                  ? nodePayLoad.output_labels[i][2]
                  : 'Save Operation'
              }}</mat-label>
              <mat-select [(ngModel)]="obj[2]">
                <mat-option
                  *ngFor="let value of savingMechanism"
                  [value]="value"
                >
                  {{ value }}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field
              appearance="fill"
              *ngIf="obj[3] !== undefined && obj[2] == 'delete_and_insert'"
            >
              <mat-label>{{
                nodePayLoad.output_labels[i][3]
                  ? nodePayLoad.output_labels[i][3]
                  : 'Columns for DI'
              }}</mat-label>
              <input matInput [(ngModel)]="obj[3]" />
            </mat-form-field>
          </div>
        </div>
      </div>

      <!-- Parameters -->
      <div class="ccard">
        <div class="ch">
          <span class="ic ci-arg">
            <svg
              viewBox="0 0 24 24"
              width="20"
              height="20"
              fill="none"
              stroke="currentColor"
              stroke-width="1.8"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <circle cx="12" cy="12" r="3" />
              <path
                d="M19 12a7 7 0 0 0-.1-1.2l2-1.6-2-3.4-2.4 1a7 7 0 0 0-2-1.2L14 2h-4l-.5 2.6a7 7 0 0 0-2 1.2l-2.4-1-2 3.4 2 1.6A7 7 0 0 0 5 12a7 7 0 0 0 .1 1.2l-2 1.6 2 3.4 2.4-1a7 7 0 0 0 2 1.2L10 22h4l.5-2.6a7 7 0 0 0 2-1.2l2.4 1 2-3.4-2-1.6A7 7 0 0 0 19 12Z"
              />
            </svg>
          </span>
          Parameters
          <span class="help2">how it runs</span>
        </div>
        <div class="cb">
          <div
            *ngFor="let object of payLoadRepeat; let i = index"
            class="param-grp"
          >
            <div class="param-top">
              <span class="param-title">{{ object.title || 'Parameters' }}</span>
              <mat-icon
                (click)="removePayload(i)"
                *ngIf="i > 0"
                class="rmv"
                >clear</mat-icon
              >
            </div>
            <app-form-buider
              #formBuilder
              [FormPayload]="object.fields"
              (dataEvent)="savePayLoadResponse($event, i)"
            ></app-form-buider>
            <div *ngIf="object.subpayloads.length" class="subgrp">
              <div
                *ngFor="let superObject of object.subpayloads; let k = index"
              >
                <div *ngFor="let subobject of superObject; let j = index">
                  <div class="param-top">
                    <span class="param-title sm">{{
                      subobject.title || 'Item'
                    }}</span>
                    <mat-icon
                      (click)="removePayload(i, k, j)"
                      *ngIf="j > 0"
                      class="rmv"
                      >clear</mat-icon
                    >
                  </div>
                  <app-form-buider
                    #formBuilder
                    [FormPayload]="subobject.fields"
                    (dataEvent)="savePayLoadResponse($event, i, k, j)"
                  ></app-form-buider>
                </div>
                <div *ngIf="superObject[0].repeatable" class="add-row">
                  <button class="btn-ghost" (click)="addPayLoad(i, k)">
                    <svg
                      viewBox="0 0 24 24"
                      width="16"
                      height="16"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2.2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    >
                      <path d="M12 5v14M5 12h14" />
                    </svg>
                    {{ superObject[0].title || 'Add' }}
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div
            *ngIf="nodePayLoad.args.repeatable === 'True' || allRepeat"
            class="add-row"
          >
            <button class="btn-ghost" (click)="addPayLoad()">
              <svg
                viewBox="0 0 24 24"
                width="16"
                height="16"
                fill="none"
                stroke="currentColor"
                stroke-width="2.2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path d="M12 5v14M5 12h14" />
              </svg>
              {{ payLoadRepeat[0].title || 'Add' }}
            </button>
          </div>
        </div>
      </div>

      <div class="save-row">
        <button class="btn-primary" (click)="save()">
          <svg
            viewBox="0 0 24 24"
            width="15"
            height="15"
            fill="none"
            stroke="currentColor"
            stroke-width="1.8"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path
              d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2Z"
            />
            <path d="M17 21v-8H7v8M7 3v5h8" />
          </svg>
          Save Steps
        </button>
      </div>
    </div>
  `,
  styleUrls: ['./form-builder-secondary.component.scss'],
  imports: [
    CommonModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    MatInputModule,
    MatDividerModule,
    MatSlideToggleModule,
    MatSelectModule,
    MatButtonModule,
    FormBuilderComponent,
    FormsModule,
    MatIconModule,
  ],
})
export class FormBuilderSecondaryComponent implements OnInit {
  @ViewChildren('formBuilder') payloadForms?: QueryList<FormBuilderComponent>;
  @Input() nodePayLoad: any;
  @Output() outputData = new EventEmitter<Output>();
  userResponse: any = [];
  inputSaveType = ['memory','source', 'destination'];
  outPutSaveType = ['memory', 'destination'];
  savingMechanism = ['replace', 'append', 'delete_and_insert'];
  columnsForDI = '';
  payLoadRepeat: any = [];
  allRepeat: boolean = false;
  nodePayLoads: any = {
    input: [['Input Data', 'destination']],
    output: [['Output Data', 'destination']],
    args: {
      repeatable: 'True',
      title: 'Bucketing',
      data_types: {
        original_column_name: 'text',
        new_bucket_column_name: 'text',
      },
      labels: {
        original_column_name: 'Enter column to be used for bucketing',
        new_bucket_column_name: 'Enter the name of new bucket column',
      },
      original_column_name: '',
      new_bucket_column_name: '',
      queries: {
        data_types: { condition: 'text', label: 'text' },
        labels: {
          condition: 'Enter Query',
          label: 'Enter label for records satisfying query',
        },
        repeatable: 'True',
        title: 'Query',
        condition: '',
        label: '',
      },
    },
  };
  dataTypesMap: any = {};
  ngOnInit(): void {
    this.addPayLoad();
  }

  argsPayloadParser(args: any, rootKey = '') {
    // const payload: any = { repeatable: false, data: [] };
    let struc: any = {
      repeatable: false,
      title: '',
      fields: { fields: [] },
      subpayloads: [],
    };
    let op: any = {};
    const { data_types, repeatable, labels, title, ...rest } = args;
    op['data_types'] = data_types;
    op['repeatable'] = repeatable;
    op['labels'] = labels;
    op['title'] = title;
    struc.title = title;
    this.dataTypesMap = { ...this.dataTypesMap, ...data_types };
    for (const [key, value] of Object.entries(rest)) {
      if (repeatable === 'True') {
        struc.repeatable = true;
      }
      let formPayload: any = {};
      if (this.isObject(value)) {
        let [formPayload, ops] = this.argsPayloadParser(value, key);
        struc.subpayloads.push([formPayload]);
        let temp: any = value;
        if (temp.repeatable === 'True') op[key] = [ops];
        else op[key] = ops;
      } else if (this.isArrayOfObjects(value)) {
        let temp: any = value;
        let oneKeyStructure = [];
        for (let obj of temp) {
          let [formPayload, ops] = this.argsPayloadParser(obj, key);
          oneKeyStructure.push(formPayload);
          try {
            op[key].push(ops);
          } catch {
            op[key] = [ops];
          }
        }
        struc.subpayloads.push(oneKeyStructure);
      } else {
        op[key] = '';
        formPayload = this.formBuilderPayloadGenerator(
          `${rootKey ? rootKey + '.' : ''}${key}`,
          value,
          this.dataTypesMap[key],
          labels[key]
        );
        struc.fields.fields.push(formPayload);
      }
    }
    return [struc, op];
  }
  isObject(obj: any) {
    return obj === Object(obj) && !(obj instanceof Array);
  }
  formBuilderPayloadGenerator(
    key: string,
    value: any,
    datatype: string,
    label: any
  ) {
    return {
      key,
      type: datatype,
      label: label,
      default: value,
      editable: true,
      validators: { required: true },
    };
  }
  isArrayOfObjects(value: any): boolean {
    // Check if the value is an array
    if (!Array.isArray(value)) {
      return false;
    }

    // Check if every element in the array is an object
    return value.every(
      (element) => typeof element === 'object' && element !== null
    );
  }
  addPayLoad(i = -1, k = -1) {
    if (i > -1) {
      let temp = this.clearDefaultValue(
        this.payLoadRepeat[i].subpayloads[k][0]
      );
      this.payLoadRepeat[i].subpayloads[k].push(temp);
      for (let [key, val] of Object.entries(this.userResponse[i])) {
        if (isArray(val)) {
          if (temp.title === val[0].title) {
            let tempData: any = {};
            Object.assign(tempData, val[0]);
            this.userResponse[i][key].push(tempData);
          }
        }
      }
    } else {
      if (isArray(this.nodePayLoad.args)) {
        if (this.payLoadRepeat.length > 0) {
          let [payLoadParsedValue, rs] = this.argsPayloadParser(
            this.nodePayLoad.args[0]
          );
          this.payLoadRepeat.push(this.clearDefaultValue(payLoadParsedValue));
          this.userResponse.push(rs);
        } else {
          for (let obj of this.nodePayLoad.args) {
            if (obj.repeatable === 'True') {
              this.allRepeat = true;
            }
            let [payLoadParsedValue, rs] = this.argsPayloadParser(obj);
            this.payLoadRepeat.push(payLoadParsedValue);
            this.userResponse.push(rs);
          }
        }
      } else {
        let [payLoadParsedValue, rs] = this.argsPayloadParser(
          this.nodePayLoad.args
        );
        this.payLoadRepeat.push(payLoadParsedValue);
        this.userResponse.push(rs);
      }
    }
  }

  removePayload(i = -1, k = -1, j = -1) {
    if (j > 0) {
      let temp = this.payLoadRepeat[i].subpayloads[k].splice(j, 1)[0];
      for (let [key, val] of Object.entries(this.userResponse[i])) {
        if (isArray(val)) {
          if (temp.title === val[0].title) {
            this.userResponse[i][key].splice(j, 1);
          }
        }
      }
    }
    if (j < 0 && i > 0) {
      this.payLoadRepeat.splice(i, 1);
      this.userResponse.splice(i, 1);
    }
  }
  savePayLoadResponse(dataForm: any, index: number, k: number = -1, j = -1) {
    if (j > -1 && k > -1) {
      try {
        let tempKeys = Object.keys(dataForm)[0];
        if (isArray(this.userResponse[index][tempKeys])) {
          this.assignObjectValues(
            dataForm[tempKeys],
            this.userResponse[index][tempKeys][j]
          );
        } else {
          this.assignObjectValues(
            dataForm[tempKeys],
            this.userResponse[index][tempKeys]
          );
        }
      } catch {
        console.error('data unavailable');
      }
    } else {
      this.assignObjectValues(dataForm, this.userResponse[index]);
    }
  }
  save() {
    this.payloadForms?.map((form) => form.generateOutput());
    this.nodePayLoad.output.forEach((innerArray: any) => {
      if (innerArray.length >= 4) {
        if (innerArray[2] == 'delete_and_insert') {
          innerArray[3] = Array.isArray(innerArray[3])
            ? innerArray[3]
            : innerArray[3].split(',').map((value: string) => value.trim());
        } else {
          innerArray[3] = [];
        }
      }
    });
    let temp: any = {
      input: this.nodePayLoad.input,
      output: this.nodePayLoad.output,
      input_labels: this.nodePayLoad.input_labels,
      output_labels: this.nodePayLoad.output_labels,
      args: this.userResponse,
    };
    console.debug('node ui output', temp);

    this.outputData.emit(temp);
  }

  assignObjectValues(source: any, target: any): void {
    const { data_types, title, labels, repeatable, ...rest } = target;
    Object.keys(rest).forEach((key) => {
      if (source.hasOwnProperty(key)) {
        target[key] = source[key];
      } else {
        if (!this.isArrayOfObjects(target[key]) && !this.isObject(target[key]))
          target[key] = null;
      }
    });
    return target;
  }

  clearDefaultValue(payload: any): any {
    const newPayload = cloneDeep(payload);

    if (newPayload.fields && newPayload.fields.fields) {
      newPayload.fields.fields.forEach((field: any) => {
        field.default = '';
      });
    }

    if (newPayload.subpayloads && newPayload.subpayloads.length > 0) {
      newPayload.subpayloads = newPayload.subpayloads.map(
        (subpayloadList: any[]) => {
          return [this.clearDefaultValue(subpayloadList[0])];
        }
      );
    }

    return newPayload;
  }
}
